<template>
  <div class="centered-container">

    <md-content class="md-elevation-3">
      <div class="title">
        <img
          src="/static/logo_azul.png"
          style="height: 30px">
      </div>

      <div class="form">
        <md-field>
          <label>Digite seu e-mail para trocar a senha</label>
          <md-input
            v-model="login.email"
            autofocus/>
        </md-field>
      </div>
      <div class="actions md-layout md-alignment-center-space-between">
        <md-button
          class="md-raised md-primary"
          style="width: 100%;"
          @click.enter="recovery">Enviar</md-button>
      </div>

      <div
        v-if="loading"
        class="loading-overlay">
        <md-progress-spinner
          :md-stroke="2"
          md-mode="indeterminate"/>
      </div>
    </md-content>
  </div>
</template>

<script>
import { httpLogin } from '../api/backend';

export default {
  name: 'Forgotpassword',
  data() {
    return {
      loading: false,
      login: {
        email: '',
      },
    };
  },
  methods: {

    recovery() {
      this.loading = true;
      setTimeout(() => {
        httpLogin.post('application.send-recovery_mail', {
          email: this.login.email,
          origin: process.env.SERVER
        })
          .then(response => {
            this.loading = false
            if (response.data.status === 1) {
              this.$toasted.show('Um link com o procedimento de alteração foi enviado para seu e-mail.', {
                theme: 'outline',
                position: 'bottom-right',
                duration: 5000,
                type: 'success',
                icon: 'check_circle'
              });
              this.$router.push({ path: '/' })
            }
          })
          .catch(() => {
            this.$toasted.show('Falha ao tentar efetuar a troca de senha!', {
              theme: 'outline',
              position: 'bottom-right',
              duration: 5000,
              type: 'error',
              icon: 'error_outline'
            });
            this.loading = false;
          })
      }, 1000);
    },
  }
};
</script>

<style type="text/css">
.centered-container {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	height: 100vh;
}
.title {
	text-align: center;
	margin-bottom: 30px;
	color: #1b8af1;
	font-size: 34px;
	font-weight: 300;

}


.form {
	margin-bottom: 60px;
}

.md-elevation-3 {
	z-index: 1;
	padding: 40px;
	width: 100%;
	max-width: 400px;
	position: relative;
	border-radius: 5px;
	border: 1px solid transparent;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0,0,0,.07);
	transition: all .5s;
}
.card {
	border-radius: 5px;
	border: 1px solid transparent;
	background-color: #fff;
	box-shadow: 0 2px 8px rgba(0,0,0,.07);
	transition: all .5s;
}
.loading-overlay {
	z-index: 10;
	top: 0;
	left: 0;
	right: 0;
	position: absolute;
	width: 100%;
	height: 100%;
	background: rgba(255, 255, 255, 0.9);
	display: flex;
	align-items: center;
	justify-content: center;
}

.button-success {
	color: #fff;
	background-color: #44bb52;
	border-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/public/password/Forgotpassword.vue